module.exports = __webpack_public_path__ + "static/media/DSC_0155.cee87743.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0155.jpg
// module id = 560
// module chunks = 0